import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { Grid, Button } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import './ConfirmationModal.css';

export default function SimpleDialog(props) {
    const { t } = useTranslation();
    const { onOk, openConfirmation} = props;

    const handleOk = () => {
        onOk();
    };

    // onClose={handleClose} 
    return (
        <Dialog maxWidth='xs' fullWidth={true} aria-labelledby="simple-dialog-title" open={openConfirmation} keepMounted>
            <div className='ugly modalBody p-4'>

                <Grid container id="ConfirmationModal">
                    <Grid item className='text-center' xs={12}>
                        <div className="heading">
                            <img src="/images/modals/reservation-pending-confirmation.png" alt={t('payment.confirmation.imageAlt')} />
                            {/*<p className="attention"><span>שימו לב ❤</span><br />*/}
                            <h1>{t('payment.confirmation.heading')}</h1>
                            <h2 className='mb-4'>
                                <p>{t('payment.confirmation.orderNumber')} <strong><span className="orderId">{props.confirmationId}</span></strong></p>
                                <p>{t('payment.confirmation.status')} <span className="attention">{t('payment.confirmation.statusPending')}</span>*</p></h2>
                            <p>{t('payment.confirmation.processingMessage')}</p>
                            <p>{t('payment.confirmation.durationMessage')}</p>
                            <p> </p>
                            <p><strong><font color="red"><u>שימו לב</u></font>: {t('payment.confirmation.emailWarning')}</strong></p>
                        </div>
                    </Grid>

                    <Grid container id="ConfirmationModal">
                        <Grid item className='text-center mt-4' xs={12}>
                            <h4>{t('payment.confirmation.billingNote')}</h4>
                        </Grid>
                    </Grid>
                    <Grid item  className='text-center mt-2' xs={12}><Button onClick={handleOk} variant='contained' color='secondary'>{t('common.buttons.close')}</Button></Grid>

                </Grid>
            </div>

        </Dialog>
    );
}
